import { PageHeader } from "../../components/common";
import { Coupons } from "./growth/Sales";

export default function CouponsPage() {
  return (
    <div className="space-y-6" data-testid="coupons-page">
      <PageHeader eyebrow="Büyüme" title="Kuponlar" subtitle="İndirim kuponu oluşturun, kullanım limiti ve geçerlilik süresi belirleyin, hangi kanaldan ne kadar kullanıldığını izleyin. Kupon, servis kaydı ekranındaki İndirim kutusundan uygulanır." />
      <Coupons />
    </div>
  );
}
